import { messages as portugueseMessages } from './pt';
import { messages as englighMessages } from './en';
import { messages as spanishMessages } from './es';

const messages = {
  ...englighMessages, ...portugueseMessages, ...spanishMessages
};

export { messages };
